export default __webpack_public_path__ + "static/media/3.601b141c.png";